import { Link } from "react-router-dom";

interface ErrorScreenProps {
  title?: string;
  message?: string;
}

export function ErrorScreen({
  title = "Something went wrong",
  message = "We encountered an error while loading your data. Please try again later.",
}: ErrorScreenProps) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100 sm:text-5xl">
          {title}
        </h1>
        <p className="mt-4 text-gray-600">{message}</p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex gap-2 items-center rounded-md bg-black px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-black/90 focus:outline-none focus:ring-2 focus:ring-black"
          >
            <span>Go back home</span> <span aria-hidden="true"> &rarr;</span>
          </Link>
        </div>
      </div>
    </main>
  );
}
